import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { ConfigurationVariationCreateListPage } from "../configuration-variation-create-list/configuration-variation-create-list";
import { Globals } from '../../../../../globals';

/**
 * Generated class for the ProductCreateSelectTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-variation-create-select-type',
    templateUrl: 'configuration-variation-create-select-type.html',
})
export class ConfigurationVariationCreateSelectTypePage {

    type: any = "";

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals) {

    }

    ionViewWillEnter() {

    }

    select(type) {
        this.type = type;
    }

    selected() {
        this.type = "";
    }

    checkState(type) {
        if (this.type == type) {
            return true
        } else {
            return false
        }
    }

    openTitles() {
        if (this.type != '') {
            this.globals.GAtrackView('Configuration', 'Configuration - Variation - Select type - Create ', this.globals.restaurant.email, 'Create/Update', 'Create variation select type', 'Configuration', this.type);

            this.navCtrl.push(ConfigurationVariationCreateListPage, {
                type: this.type,
            });


        }

    }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/configuration-variations-create/configuration-variation-create-select-type/configuration-variation-create-select-type.ts